<template>
    <div>
        <v-card flat>
            <v-card-actions class="pa-0" v-if="!is_domestic">
    <v-row no-gutters align="center" class="flex-grow-1">

        <!-- Warnings -->
        <v-col class="d-flex flex-column">
            <small
                v-if="order.customs_declaration && order.customs_declaration.modified"
                class="orange--text mb-1"
            >
                <v-icon small color="warning" class="mr-2 mt-n1">
                    mdi-alert
                </v-icon>
                CAUTION: Customs declaration has been modified and will override order data
            </small>

            <small
                v-if="order.override_line_items && order.override_line_items.modified"
                class="orange--text"
            >
                <v-icon small color="warning" class="mr-2 mt-n1">
                    mdi-alert
                </v-icon>
                CAUTION: Original product names or values may have been overridden
            </small>
        </v-col>

        <!-- Action icons -->
        <v-col cols="auto" class="text-right">

            <v-tooltip bottom v-if="0">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon small color="blue" @click="edit_customs = true">
                            mdi-file-document-edit-outline
                        </v-icon>
                    </v-btn>
                </template>
                <span>View/Edit Customs Declaration.</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon small color="blue" @click="refresh_international_data">
                            mdi-refresh
                        </v-icon>
                    </v-btn>
                </template>
                <span>Refresh International Data from Shopify.</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon small color="blue" @click="edit = true">
                            mdi-pencil
                        </v-icon>
                    </v-btn>
                </template>
                <span>Override Product Data.</span>
            </v-tooltip>

        </v-col>

    </v-row>
</v-card-actions>
        </v-card>
        <v-dialog v-model="edit" width="800" min-height="500">
            <EditProducts :order="order" :edit="edit" v-on:close="edit=false"/>
        </v-dialog>
        <v-dialog v-model="edit_customs" width="1200" min-height="500">
            <CustomsDeclaration :order="order" :edit="edit_customs" v-on:close="edit_customs=false"/>
        </v-dialog>
    </div>
</template>

<script>
import orderTools from "@/V2/helpers/orderTools";
import EditProducts from "@/V2/components/Orders/EditProducts.vue"
import CustomsDeclaration from "@/V2/components/Orders/CustomsDeclaration.vue"

export default {
    name: 'InternationalActions',
    props: ['order'],
    components: {
        EditProducts,
        CustomsDeclaration
    },
    data: function () {
        return {
            orderTools: orderTools,
            edit: false,
            edit_customs: false
        }
    },
    methods: {
        refresh_international_data() {
            this.orderTools.get_international_data(this.order, false)
        },

    },
	computed : {
        is_domestic(){
            return orderTools.is_domestic(this.order)
        }
    }
}
</script>

